<template>
  <div class="my-0 text-center">
    <h1 class="text-4xl">Page Not Found</h1>
  </div>
</template>

<style scoped>
h1 {
  background-color: #C9D99E;
}
</style>

<script>
export default {
  name: 'notFound',
};
</script>
